import ElementUI from 'element-ui';
import 'core-js/fn/array/flat-map';
import '@/style/theme/element-#FAAD14/index.css';
import '@/style/index.css';
import Vue from 'vue';
import pluginsRegister from '@/plugins';
import componentsRegister from '@/components';
import store from './store';
import App from './App';
import router from './router';
// 引入mockjs
// require("./mock/mock.js");

Vue.config.productionTip = false;
Vue.use(ElementUI)
  .use(componentsRegister)
  .use(pluginsRegister);
Vue.prototype.$EventBus = new Vue();
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js